import React from "react";
import APIService from "../../Service/APIService";
import GenericDashboard from "../GenericDashboard/GenericDashboard";
import { Button, Select, Col, Row, Form, Modal } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import SectionHeader from "../../common/section-header/index.js";
import { colors } from "../../theme/colors";

const ManufacturerAccounts = (props) => {
  const { manufacturerData } = props;
  const canAddAccount = props.canAddAccount !== false;
  const [accounts, setAccounts] = React.useState([]);
  const getAccounts = async () => {
    if (manufacturerData) {
      const apiServe = new APIService();
      console.log("Manufacturer Data: ", manufacturerData);
      const response = await apiServe.getDataFromBackend(
        `getaccountsfrommanufacturer?manufacturerID=${manufacturerData.ID}`
      );
      console.log("Accounts from Manufacturer: ", response?.data?.data);
      setAccounts(response?.data?.data);
    } else {
      console.log("Manufacturer Data is null");
    }
  };
  React.useEffect(() => {
    // console.log("Manufacturer Accounts component mounted");
    // console.log("Manufacturer Data: ", manufacturerData);
    getAccounts();
  }, [manufacturerData]);
  const [selectedAccount, setSelectedAccount] = React.useState(null);
  const [accountOptions, setAccountOptions] = React.useState([]);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleAddAccountClick = async () => {
    if (!canAddAccount) return;
    try {
      const apiServe = new APIService();
      const response = await apiServe.getDataFromBackend(
        "getaccountoptionsformanufacturer"
      );
      console.log("All Accounts: ", response);
      const allAccounts = response?.data?.data;
      const options = Array.isArray(allAccounts)
        ? allAccounts.map((ele) => ({
            value: ele.ID,
            label: ele.AccountName,
          }))
        : [];
      setAccountOptions(options);
    } catch (error) {
      console.error("Failed to fetch account options:", error);
      Swal.fire(
        "Error!",
        "Failed to load account options. Please try again.",
        "error"
      );
    }
  };

  const submitAccount = async () => {
    if (!selectedAccount) {
      Swal.fire("Error!", "Please select an account.", "error");
      return;
    }

    const apiServe = new APIService();
    const data = {
      ManufacturerID: manufacturerData.ID,
      AccountID: selectedAccount,
    };
    console.log("Add Account Data: ", data);

    // check if account already exists in accounts
    if (accounts.find((ele) => ele.ID === selectedAccount)) {
      Swal.fire("Error!", "This account is already added.", "error");
      return;
    }

    try {
      setIsSubmitting(true);

      const response = await apiServe.addDataToBackend(
        data,
        "addaccounttomanufacturer"
      );
      console.log("Add Account Response: ", response);
      const isApproved = response?.data?.IsApproved === true;
      const createdProductsCount =
        Number(response?.data?.CreatedProductsCount) || 0;

      await getAccounts();
      setModalChildVisible(false);
      setSelectedAccount(null);
      Swal.fire({
        icon: "success",
        title: isApproved ? "Account Added" : "Approval Required",
        text: isApproved
          ? `Account approved and ${createdProductsCount} products added.`
          : "Account added and sent for approval.",
      });
    } catch (error) {
      console.error("Failed to add account/manufacturer relationship:", error);
      const errorMessage =
        error?.response?.data?.error ||
        error?.response?.data?.data ||
        "Failed to add account. Please try again.";
      Swal.fire("Error!", errorMessage, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const [modalChildVisible, setModalChildVisible] = React.useState(false);
  const handleModalOk = () => {
    setModalChildVisible(false);
  };
  const handleModalCancel = () => {
    setModalChildVisible(false);
    setSelectedAccount(null);
  };
  const handleChildNew = async () => {
    if (!canAddAccount) return;
    await handleAddAccountClick();
    setModalChildVisible(true);
  };

  const handleSelectChange = (value) => {
    setSelectedAccount(value);
  };
  console.log(accounts, "accounts >>>>> 1");
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <SectionHeader
        title="Accounts"
        showButton={false}
        rightContent={
          canAddAccount && (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              style={{ background: colors["primaryColor"] }}
              onClick={handleChildNew}
            >
              Add Account
            </Button>
          )
        }
      />
      {accounts && (
        <div>
          <GenericDashboard
            data={accounts}
            screen="ManufacturerAccountDashboard"
          />
          <Modal
            open={modalChildVisible}
            title="Add Account"
            onOk={handleModalOk}
            onCancel={handleModalCancel}
            centered={true}
            footer={null}
            style={{ width: "800px" }}
          >
            <div>
              <Form layout="vertical">
                <Row gutter={16}>
                  <Col span={18}>
                    <Form.Item label="Account Name">
                      <Select
                        defaultValue="Choose Account"
                        onChange={(value) => handleSelectChange(value)}
                        options={accountOptions}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Button
                  type="primary"
                  style={{ background: "#27a907" }}
                  onClick={submitAccount}
                  loading={isSubmitting}
                >
                  Add Account
                </Button>
              </Form>
            </div>
          </Modal>
        </div>
      )}
    </div>
  );
};

export default ManufacturerAccounts;
